module.exports = __webpack_public_path__ + "img/arrow-left.242f4827.svg";